import { connect } from 'react-redux';
import EnhancementButtons from './enhancementButtons';

function mapStateToProps(state) {
  return {
    clientWidth: state.clientSize.width,
    buttonListWidth: state.buttonListWidth,
    listContainerWidth: state.listContainerWidth,
    sidePanelOpen: state.sidebar.isOpen,
  };
}

export default connect(mapStateToProps)(EnhancementButtons);
